// @ts-nocheck
import getFormData, { headers } from 'utils/getFormData';
import axios from 'config/api';
import { authenticated, api } from './index';
import globalHeaders from '../../utils/globalHeaders';
import { API_URL as API_URI } from '../../config/constants';

export const getProjects = (params) =>
  authenticated(api).get(`/project/?${params}`);

export const getProject = (params) =>
  authenticated(api).get(`/project/${params.id}`);

export const createProject = (payload) =>
  authenticated(api).post(
    '/project/',
    getFormData({
      ...payload,
    }),
    {
      headers,
    },
  );

export const updateProject = (payload) =>
  authenticated(api).put(
    `/project/${payload.id}/`,
    getFormData({
      ...payload,
    }),
    {
      headers,
    },
  );

const get = (url) =>
  axios.get(url, {
    headers: { ...globalHeaders() },
  });

export const deleteProject = (payload) =>
  authenticated(api).post(`/project/${payload.project}/archive/`, {
    archive: payload.archive,
  });

export const favouriteProject = (payload) =>
  authenticated(api).post(`/project/${payload.project}/favourite/`, {
    favourite: payload.favourite,
  });

export const getCountries = () => get('/country/');

export const getStates = () => authenticated(api).get('/state/');

export const getProjectClients = () => get('/v1.1/project_drop_down_clients/');

export const getProjectSegments = () =>
  get('/v1.1/project_drop_down_segments/');

export const getProjectClaimPaymentAct = () =>
  get('/v1.1/project_drop_down_claim_payment_act/');

export const getProjectCodeList = () =>
  get('/v1.1/project_drop_down_resource_code_list/');
